import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { Activite } from '@app/models/carnet-liaison';
import { CarnetHeureFormatPipe } from '../../carnet-liaison.pipe';

@Component({
  selector: 'app-carnet-activite',
  templateUrl: './carnet-activite.component.html',
  styleUrl: './carnet-activite.component.scss',
  standalone: true,
  imports: [SharedModule, CarnetHeureFormatPipe],
})
export class CarnetActiviteComponent {
  data = input.required<Activite>();
}
